import React, { memo } from 'react'

import DropdownMenu from 'components/CommonUI/Dropdown'
import { equal } from 'utils/memoEqual'

const FilterItem = ({
  emptyValue = '',
  itemData = [],
  count = '',
  disabled = false,
  handleSelectedClick,
  selectedValue,
}) => {
  const selectedValueClassList = selectedValue?.value ? 'selected' : ''

  return (
    <div className="filter_item_container">
      <span className={`filter_item_count ${selectedValueClassList}`}>
        {count}
      </span>
      <DropdownMenu
        emptyValue={emptyValue}
        classNameContainer="filter_item_dropdown_container"
        disabled={disabled}
        handleSelectedClick={handleSelectedClick}
        selectedValue={selectedValue}
        withSearch={true}
      >
        {itemData.map((item) => (
          <DropdownMenu.Item key={item.id} itemData={item} />
        ))}
      </DropdownMenu>
    </div>
  )
}

export default memo(FilterItem, equal)
